export default () => {
  const injuryCheckbox = $("#incident_report_incident_is_fall_or_minor_accident_injury");
  const injuryExplainTextField = $("#incident_report_injury_explain");
  const injuryExplainContainer = $(".injury-explain");

  if (!injuryCheckbox.is(":checked")) {
    injuryExplainContainer.hide();
  }

  injuryCheckbox.on("change", () => {
    if (injuryCheckbox.is(":checked")) {
      injuryExplainContainer.show();
    } else {
      injuryExplainTextField.val("");
      injuryExplainContainer.hide();
    }
  });
};
